
<script>

import { defineComponent } from 'vue'

import Popper from "vue3-popper";
import CheckboxToggle from '@/ui/CheckboxToggle'

//data
import { getLibraryOptions } from '@/services/serviceLibrary';
import { getDocumentsByLibrary } from '@/services/serviceDocument';

export default defineComponent({
  name: 'ComponentLibrary',
	data() {
		return {
			optionsLibraries: [],
			paddingBottom: 0,
			documents: [],
			libraryId: '',
			showName: false,
			workContent:{}
		}
	},
  props: {
	'content': Object
  },
  emits: ["content","changeContent"],
  components: {
    Popper
	,CheckboxToggle
  }
  ,mounted () {
		this.loadOptions();
		this.libraryId=this.content.fields.libraryId;
		if(this.content.fields.showName){
			this.showName=this.content.fields.showName;
		}
		if(this.content.fields.paddingBottom){
			this.paddingBottom=this.content.fields.paddingBottom;
		}
		this.workContent = this.content;
		this.loadPreview();
  },
  
	methods: {

		// load data form
		loadOptions:function(){
			
			getLibraryOptions().then(response => {
				if(!response.statusText){
					this.optionsLibraries = response.optionsLibraries;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

		loadPreview:function(){
			
			if(this.workContent.fields.libraryId){

				getDocumentsByLibrary({libraryId:this.workContent.fields.libraryId}).then(response => {
					if(!response.statusText){
						this.preloader=false
						this.documents = response.documents;
					}else{
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

			}else{
				this.documents = [];
			}
		
		},

		sendContent:function(){
			this.workContent.content = JSON.stringify(this.workContent.fields);
			this.$emit('changeContent', this.workContent)
		},

		onChangeLibraryId:function(){
			this.workContent.fields.libraryId=this.libraryId;
			this.sendContent();
		},

		onChangeShowName:function(e){
			this.workContent.fields.showName=e;
			this.sendContent();
		},

		onChangePaddingBottom:function(){
			console.log(this.paddingBottom)
			this.workContent.fields.paddingBottom=this.paddingBottom;
			this.sendContent();
		}
	},
	
	watch: {
       
	},
	
	created() {

	}
})
</script>

<template>
	<div class="row">
		<div class="col-md-4 col-12">
			<label><b>{{ $t('msgCore.Library') }}</b></label>
			<select v-model='libraryId' class="form-control form-control-sm" v-on:change="onChangeLibraryId();loadPreview();" >
				<option  value="">{{ $t('msgCore.selectLibrary') }}</option>
				<option v-for="(option) in optionsLibraries" :value="option.value" :key="option">{{ option.title }}</option>
			</select>
		</div>
		
		<div class="col-12 col-md-4">
			<label><b>{{ $t('msgCore.showName') }}</b></label>
			<CheckboxToggle :key="libraryId" :data="showName" @onClick="onChangeShowName"></CheckboxToggle>
		</div>

		<div class="col-12 col-md-4">
			<label><b>{{ $t('msgCore.paddingBottom') }}</b></label><br>
			
			<div v-for="(option) in 5" :key="option" class="form-check-inline">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" :name="`paddingBottom${libraryId}`" v-model='paddingBottom' v-on:change="onChangePaddingBottom()" :value="option">
					{{ option }}
					<span class="circle">
						<span class="check"></span>
					</span>
				</label>
			</div>
			
		</div>

		<div v-if="documents.length>0" class="col-12">
			<div class="table-responsive">
				<table class="table table-hover table-sm">
							
					<thead>
						<tr>
							<th>ID</th>
							<th></th>
							
							<th>{{$t('msgCore.Title')}}</th>
							
							<th>{{$t('msgCore.Extension')}}</th>
							
							<th>{{$t('msgCore.Size')}}</th>
							
							<th>{{$t('msgCore.Created')}}</th>
							
							<th>{{$t('msgCore.Modified')}}</th>

							<th>{{$t('msgCore.AccessLevel')}}</th>									
						</tr>
					</thead>
			
				
					<tr v-for="document in documents" :key="document" >
						<td>{{document.id}}</td>
						
						

						<td  :title="$t('msgCore.' + document.state_name)">
							<i class="fas fa-circle" :class="{'text-success':document.state==1,'text-danger':document.state==2}" ></i>
						</td>	

					
							
						<td><a :href="document.url">{{document.title}}</a></td>
						
						<td>{{document.extension}}</td>
						
						<td>{{document.fileSize}}</td>
						
						<td>
							<Popper :content="document.creator+', '+document.createdView">
								<button class="personCircle v-center" v-bind:style="{background:document.creatorColor}">{{ document.creatorNameLetter+''+document.creatorSurnameLetter }}</button>
							</Popper>
						</td>

						<td>
							<Popper v-if="document.editor" :content="document.editor+', '+document.modifiedView">
								<button class="personCircle v-center" v-bind:style="{background:document.editorColor}">{{ document.editorNameLetter+''+document.editorSurnameLetter }}</button>
							</Popper>
						</td>
						
						<td>{{document.access_name}}</td>	
					
					</tr>
				
				</table>
			</div>
			
		</div>


	</div>
  </template>